<!--
    课件操作模块
    作用：提供“move: '移动至',copy: '复制至',addNavItem: '添加导航',editNavItem: '编辑导航',replaceNav: '切换导航',editNavLeaf: '添加子菜单',setTemplate: '转换为模版'”；
    实现：窗口操作；
    组件：element->el-dialog
    注释：WJ
-->
<template>
    <el-dialog
        :title="titleEnum[type]"
        :visible.sync="dialogVisible"
        :append-to-body="true"
        :close-on-click-modal="false"
        width="460px"
        :before-close="handleClose">
        <div>
            <el-alert
                    v-if="['setTemplate'].includes(type)"
                    class="warn"
                    title="注意：课件被设置为模板后，会存入【模板】》【我的校区】版块内，存入后校区内的所有账号都可以使用该模板。"
                    type="warning"
                    show-icon>
            </el-alert>
            <ElementForm
                ref="form"
                class="column"
                :form.sync="newForm"
            />
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
          </span>
    </el-dialog>
</template>

<script>
    import {mapState} from 'vuex'
    import * as commonServer from "../../api/common";
    import {fields} from './fields'
    import {getRandomOverByObj} from "../../utils/utils";

    export default {
        name: "opt-to-block",
        props: {
            type: String,
            form: Array,
            visible: {
                type: Boolean,
                default: true
            },
            optToBlockItem: [Array, Object],
            menusData: [Array, Object]
        },
        computed: {
            ...mapState(['menusData', 'menusDataIds', 'mulSelect']),
            isShop(){
                return `${this.$route.query.is_shop}` === 'true'
            },
            addResource(){
                return this.isShop?'addResourceShop':'addResource'
            },
        },
        watch:{
            type(vl){this.newType = vl},
            newType(vl){this.$emit('update:type', vl)},
            visible(vl){this.dialogVisible = vl},
            dialogVisible(vl){
                this.$emit('update:visible', vl)
            },
            form(vl){this.newForm = vl},
            newForm(vl){this.$emit('update:form', vl)},
            menusData(vl){this.newMenusData = vl},
            newMenusData:{
                handler(vl) {
                    this.$emit('update:menusData', vl)
                },
                deep: true
            }
        },
        mounted() {
            this.$nextTick(()=>{
                this.init()
            })
        },
        data(){
            return {
                newType: this.type,
                titleEnum: {
                    move: '移动至',
                    copy: '复制至',
                    addNavItem: '添加导航',
                    editNavItem: '编辑导航',
                    replaceNav: '切换导航',
                    editNavLeaf: '添加子菜单',
                    setTemplate: '转换为模版'
                },
                dialogVisible: this.visible,
                newForm: fields[this.type],
                // 当前板块及课程状态集
                newMenusData: this.menusData
            }
        },
        methods: {
            async init(){
                try {
                    this.newForm[0].options = this.$utils.getNavList({})
                    // 如果是复制，默认选中当前板块
                    switch (this.type) {
                        case 'copy':
                            // debugger
                            this.newForm[0].value = `${this.newMenusData.blocksSelected}`
                            console.log('copy==>',this.newForm[0].value)
                            break;
                        case 'editNavItem':
                            this.newForm[0].value = this.optToBlockItem.name
                            break;
                        case 'replaceNav': {
                            let resMy = null
                            if(!this.$store.getters.isPlat) {
                                resMy = await commonServer.default.getResourceList({
                                    clientsId: this.$store.state.initConfig.school_id,
                                    sort: 'scenes_stage'
                                })
                            }
                            let resShop = null
                            resShop = await commonServer.default.getResourceShopList({
                                clientsId: this.$store.state.initConfig.school_id,
                                sort: 'scenes_stage'
                            })
                            console.log(resMy)
                            // id/my 或者 id/shop 维护当前选中导航是属于我的还是公共
                            this.newForm[0].options = []
                            if(resMy){
                                this.newForm[0].options.push({value: '我的',childrens:resMy.items.map(v=>{
                                    return {
                                        key: `${v.id}/my`,
                                        value: v.name
                                    }
                                })})
                            }
                            if(resShop){
                                this.newForm[0].options.push({value: '公共',childrens:resShop.items.map(v=>{
                                    return {
                                        key: `${v.id}/shop`,
                                        value: v.name
                                    }
                                })})
                            }
                            // 获取导航列表
                            this.newForm[0].value = `${this.$store.state.menusData.scenes_stage_id}/${this.$store.state.menusData.scenes_stage_shop?'shop':'my'}`
                            break;
                        }
                    }
                }catch (e) {
                    console.log('init==>fail', e)
                }
            },
            handleClose() {
                this.dialogVisible = false
                this.newForm[0].value = ''
                this.$emit('onCancel')
            },
            async submit() {
                let state = this.$refs.form.validateForm()
                if(state){
                    console.log('OptToBlock==>', this.type)
                    console.log('this.newForm',this.newForm);
                    let value = this.newForm[0].value
                    let status = true
                    const blockUnique = value[value.length - 1]
                    console.log('blockUnique==>', blockUnique)
                    switch (this.type) {
                        case 'move': {
                            // 1. 删除当前的课程
                            console.log('优化速度==>move',this.mulSelect)
                            let deleteNode = {}
                            // 优先处理批量
                            if(this.mulSelect && this.mulSelect.length){
                                this.mulSelect.forEach(v=>{
                                    deleteNode = this.sigleMove({
                                        unique: v,
                                        blockUnique
                                    })
                                })
                                this.$store.state.mulSelect = null
                            } else {
                                deleteNode = this.sigleMove({
                                    unique: this.optToBlockItem.unique,
                                    blockUnique
                                })
                            }

                            if(deleteNode && deleteNode.unique) {
                                console.log('retro lessonSelected12')
                                this.$store.state.menusData.lessonSelected = deleteNode.unique
                                this.$store.state.menusData.lessonSelectedConfig = {type: deleteNode.uniqueNode.type}
                            } else {
                                console.log('retro lessonSelected13')
                                this.$store.state.menusData.lessonSelected = ''
                                this.$store.state.menusData.lessonSelectedConfig = {}
                            }
                            const children = this.menusDataIds[(deleteNode && deleteNode.parentNode.unique) || '']?.children
                            $eventBus.$emit('onCurForm', children || [])
                            $eventBus.$emit('onFlashLesson')
                            break;
                        }
                        case 'copy': {
                            // 优先处理批量
                            if(this.mulSelect && this.mulSelect.length){
                                this.mulSelect.forEach(v=>{
                                    this.sigleCopy({
                                        unique: v,
                                        blockUnique
                                    })
                                })
                                this.$store.state.mulSelect = null
                            } else {
                                this.sigleCopy({
                                    unique: this.optToBlockItem.unique,
                                    blockUnique
                                })
                            }

                            // // 1.根据目录unique,找到当前目录节点
                            // // 2.复制内容到目录节点中，如果存在字集直接追加，否则创建字集设置一个
                            // const node = this.$utils.curSelectedNode({unique: value[value.length - 1]})
                            // console.log(node, value, this.optToBlockItem)
                            // let newObj = this.optToBlockItem
                            // newObj = getRandomOverByObj(newObj)
                            //
                            // // TODO 复制课件
                            // const operation = [{node: 'children',toUnique: '', leafUnique: node.unique,data:newObj,operation: 'add'}]
                            // $eventBus.$emit('__save__',true,null, operation)
                            // console.log('操作==>复制课件', operation)
                            //
                            // if (!node.children || (node.children && node.children.length <= 0)) {
                            //     node.children = [newObj]
                            // } else {
                            //     node.children.push(newObj)
                            // }
                            // this.menusDataIds[value[value.length - 1]].children = node.children
                            // this.menusDataIds[`${newObj.unique}`] = newObj
                            $eventBus.$emit('onFlashLesson')
                            break;
                        }
                        case 'addNavItem': {
                            const self = this
                            let data = this.$store.state.menusData
                            console.log('添加导航==>', data, this.optToBlockItem)

                            let name = this.newForm[0].value
                            let isNew = !data.blocksForm || data.blocksForm.length === 0

                            let obj = {shop:this.$store.state.menusData.scenes_state_shop}
                            obj.fn = () => {
                                let date=new Date();
                                let datetime=date.getFullYear()+""+date.getMonth()+""+date.getDate()+""+date.getHours()+""+date.getMinutes()+""+date.getSeconds();
                                let unique = "nav_"+datetime+"_"+Math.floor(Math.random()*999999);
                                let obj = {
                                    name,
                                    unique,
                                    leaf: []
                                }
                                this.$store.state.menusDataIds[`${obj.unique}`] = obj
                                data.blocksForm.push(obj)
                                data.blocksSelected =  obj.unique

                                data.lessonSelected = ''
                                data.lessonSelectedConfig = {}
                                data.willGo = ''
                                data.willGoConfig = {}

                                this.$store.dispatch('setMenusData', data)

                                // TODO 添加导航
                                const operation = [{node: 'leaf',data:{name, unique},operation: 'add'}]
                                $eventBus.$emit('__save__',true,null, operation)
                                console.log('操作==>添加导航', operation)

                                // TODO 临时处理新增bug
                                const fn = setInterval(()=>{

                                    if(!this.$store.state.menusData.blocksSelected){
                                        console.log("临时处理新增bug:",this.$store.state.menusDataIds,this.$store.state.menusData);
                                        this.$store.state.menusData.blocksSelected = unique
                                        clearInterval(fn)
                                    }
                                }, 500)
                                let fn2 = setTimeout(()=>{
                                    clearTimeout(fn2)
                                    clearInterval(fn)
                                }, 10000)

                                // 如果是第一次创建，则默认创建一个空页面
                                // console.log(this.$store.state.menusData.blocksSelected)
                                // debugger
                            }
                            if(isNew) {
                                obj.name = name
                            }
                            // TODO 更新导航接口
                            this.updateNavData(obj)

                            if(this.optToBlockItem.addPage) {
                                self.$emit('addPage')
                            } else {
                                if(this.optToBlockItem.fn) {
                                    // this.$store.state.saving = true
                                    this.optToBlockItem.fn()
                                } else {
                                    // 清空课件
                                    $eventBus.$emit('onCurForm', [])
                                    $eventBus.$emit('onFlashLesson')
                                }
                            }
                            break;
                        }
                        case 'editNavItem': {
                            console.log('编辑导航==>', this.optToBlockItem)

                            const data = this.$utils.curSelectedNode({data: this.$store.state.menusData.blocksForm, unique: this.optToBlockItem.unique})
                            this.optToBlockItem = {
                                ...data,
                                name: this.newForm[0].value
                            }

                            this.$utils.curSelectedNode({
                                unique: this.optToBlockItem.unique,
                                type: 'update',
                                updateData: this.optToBlockItem
                            })

                            console.log('888==>', this.$store.state.menusData)
                            this.$store.state.menusData = JSON.parse(JSON.stringify(this.$store.state.menusData))

                            // TODO 编辑菜单
                            const operation = [{node: 'leaf', toUnique:this.optToBlockItem.unique,data:this.optToBlockItem.name, operation: 'editName'}]
                            $eventBus.$emit('__save__',true,null, operation)
                            console.log('操作==>编辑菜单', operation)

                            // let data = this.$store.state.menusData
                            // data.blocksForm[this.optToBlockItem.index].name = this.newForm[0].value
                            // this.$store.dispatch('setMenusData', data)
                            // // TODO 更新导航接口
                            // // this.updateNavData({shop:this.$store.state.menusData.scenes_state_shop})
                            break;
                        }
                        case 'editNavLeaf': {
                            let node = this.$utils.curSelectedNode({
                                unique: this.optToBlockItem.unique
                            })

                            let obj = {
                                unique: Date.parse(new Date()),
                                name: this.newForm[0].value
                            }
                            this.$store.state.menusDataIds[`${obj.unique}`] = obj

                            // TODO 添加子导航
                            const operation = [{node: 'leaf',toUnique: this.optToBlockItem.unique, data:obj,operation: 'append'}]
                            console.log('retro lessonSelected14')
                            this.$store.state.menusData.lessonSelected = ''
                            this.$store.state.menusData.lessonSelectedConfig = {}
                            this.$store.state.menusData.willGo = ''
                            this.$store.state.menusData.willGoConfig = {}

                            $eventBus.$emit('__save__',true,null, operation)
                            console.log('操作==>添加子导航', operation)

                            if(node.leaf && node.leaf.length>=0){
                                obj.id =`${this.optToBlockItem.id}`+`-${node.leaf.length}`
                                node.leaf.push(obj)
                            }else{
                                obj.id =`${this.optToBlockItem.id}`+`-0`
                                node.leaf = [obj]
                            }

                            this.$store.state.menusData.blocksSelected = obj.unique

                            console.log('888==>', this.$store.state.menusData)
                            this.$store.state.menusData = JSON.parse(JSON.stringify(this.$store.state.menusData))

                            // 清空课件
                            $eventBus.$emit('onCurForm', [])
                            $eventBus.$emit('onFlashLesson')
                            break;
                        }
                        case 'replaceNav': {
                            status = false
                            this.$confirm('此操作将会清空当前编辑的所有课程, 是否继续?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.$store.state.menusData = {
                                    scenes_stage_id: "",
                                    scenes_state_shop: false,
                                    blocksForm: null,
                                    blocksSelected: '',
                                    lessonSelected: '',
                                    lessonSelectedConfig: {}
                                }
                                // 先清空课件列表
                                $eventBus.$emit('onCurForm', [])
                                const fn = setTimeout(()=>{
                                    // TODO 切换导航，对应的导航类型也要更新
                                    this.replaceNavGo()
                                    this.handleClose()
                                    clearTimeout(fn)
                                })
                            }).catch(() => {
                            });
                            break;
                        }
                        case 'setTemplate': {
                            this.onSetTemplate({name: value})
                            break
                        }
                        default:
                    }
                    status && this.handleClose()
                }
            },
            // 创建一个模版 根据选中的课件
            async onSetTemplate({name}){
                const children = []
                this.mulSelect.map(v=>{
                    children.push(this.menusDataIds[v])
                })
                const unique = Math.random() + Math.random()
                const blocksForm = [
                    {
                        children,
                        id: "1",
                        name: `${name}模版`,
                        unique
                    }
                ]
                const h5_remote = {
                    blocksForm,
                    blocksSelected: unique,
                    lessonSelected: children[0].unique,
                    lessonSelectedConfig: {type: children[0].type}
                }
                const obj = {
                    clientsId: this.$store.state.initConfig.school_id,
                    sort:'template',
                    categoryId:this.$store.state.initConfig.category_id,
                    name,
                    "title": name,
                    "type": 'online',
                    "cover": 'https://ucenter.yunkedun.com',
                    attributes:{
                        "cover":'https://ucenter.yunkedun.com',
                        "h5_original": [],
                        h5_remote,
                        "cocos_original": [],
                        "cocos_remote": []
                    }
                }
                console.log('设置模版==>', name, obj)

                const res = await commonServer.default[this.addResource](obj)
                if(res && res.status_code === 200){
                    this.$message.success(`【${name}】模版添加成功`)
                    this.$store.state.mulSelect =  null
                } else {
                    this.$message.error(`【${name}】模版添加失败`)
                }
            },
            // 移动一个课件
            sigleMove({unique, blockUnique}){
                console.log('sigleMove==>', unique, blockUnique)

                const deleteNode = this.$utils.getObjByCurLesson({
                    unique,
                    type: 'delete'
                })
                const deleteNode1 =  this.menusDataIds[this.menusData.blocksSelected]
                if(deleteNode1 && deleteNode1.children){
                    let index = -1
                    deleteNode1.children.map((v, i)=>{
                        if(`${v.unique}` === `${unique}`){
                            index = i
                        }
                    })
                    if(index>-1) deleteNode1.children.splice(index, 1)
                }

                // 2.移动到其他板块的下面
                const node = this.menusDataIds[blockUnique]
                const nodeMenu = this.$utils.curSelectedNode({unique: blockUnique})
                let newObj = this.menusDataIds[unique]

                // TODO 移动课件 先删后加
                const operation = [
                    {node: 'children',toUnique: newObj.unique,operation: 'delete'},
                    {node: 'children',toUnique: '', leafUnique: node.unique,data:newObj,operation: 'add'}
                ]
                $eventBus.$emit('__save__',true,null, operation)
                console.log('操作==>移动课件', operation)

                if (!node.children || (node.children && node.children.length <= 0)) {
                    node.children = [newObj]
                    nodeMenu.children = this.$_.cloneDeepWith(node.children)
                } else {
                    node.children.push(newObj)
                    nodeMenu.children = this.$_.cloneDeepWith(node.children)
                }
                return deleteNode

            },
            // 复制一个课件
            sigleCopy({unique, blockUnique}){
                console.log("方法参数",unique,blockUnique);
                // 1.根据目录unique,找到当前目录节点
                // 2.复制内容到目录节点中，如果存在字集直接追加，否则创建字集设置一个
                const node = this.menusDataIds[blockUnique] // this.$utils.curSelectedNode({unique: blockUnique})
                console.log("2、复制操作处理：node,this.menusDataIds",node,this.menusDataIds);
                const nodeMenu = this.$utils.curSelectedNode({unique: blockUnique})//
                console.log("3、场景nodeMenu：",nodeMenu);
                let newObj =  JSON.parse(JSON.stringify(this.menusDataIds[unique]));
                console.log("4、新课程：",newObj);
                newObj = getRandomOverByObj(newObj)
                console.log("5、新生成一个随机字段：",newObj);

                // TODO 复制课件
                const operation = [{node: 'children',toUnique: '', leafUnique: node.unique,data:newObj,operation: 'add'}]
                $eventBus.$emit('__save__',true,null, operation)
                
                if (!node.children || (node.children && node.children.length <= 0)) {
                    node.children = [newObj]
                    nodeMenu.children = this.$_.cloneDeepWith(node.children)
                } else {
                    node.children.push(newObj)
                    nodeMenu.children = this.$_.cloneDeepWith(node.children)
                }
                // 如果菜单中存在重复unique,重新计算A
                //node.children = this.$utils.calcNavIsUnique({data:node.children})
                this.menusDataIds[blockUnique].children = node.children
                this.menusDataIds[`${newObj.unique}`] = newObj
            },
            // 切换导航
            async replaceNavGo(){
                let arr = this.newForm[0].value
                let id = arr
                if(this.newForm[0].value.indexOf('/')>-1){
                    arr = this.newForm[0].value.split('/')
                    id = arr[0]
                }
                let getResourceDetail = arr[1] === 'shop'?'getResourceShopDetail': 'getResourceDetail'
                // 获取导航详情
                const res = await commonServer.default[getResourceDetail]({
                    id,
                    clientsId: this.$store.state.initConfig.school_id
                })
                // 获取导航id 及 导航列表
                console.log('获取导航id 及 导航列表==>', res.data.id, res.data.attributes.options)
                let navs = res.data.attributes.options

                // 兼容旧数据格式 ['xx', 'yy'] 转 [{name: 'xx', unique: xxx},{name: 'yy', unique: yyy}]
                if(navs && navs[0] && typeof navs[0] === 'string'){
                    navs = navs.map(v=>{
                        return {
                            name: v,
                            unique: Date.parse(new Date()) + Math.random()
                        }
                    })
                }

                let data = {
                    scenes_stage_id: res.data.id, // 当前导航id
                    scenes_stage_shop: arr[1] === 'shop',
                    blocksForm: navs.map(v=>{
                        return {
                            ...v
                        }
                    }),
                }
                // 切换导航后默认选中第一个菜单
                data.blocksSelected = this.$utils.getFirstMenu({data: data.blocksForm})
                this.$store.dispatch('setMenusData', data)

                const fn = setTimeout(()=>{
                    this.$store.state.menusData.blocksForm = this.$utils.calcNavIsUnique({data: data.blocksForm })
                    const {menusIds} = this.$utils.one2TwoTree({data: this.$store.state.menusData})
                    this.$store.state.menusDataIds = menusIds
                    // 通知服务端刷新配置
                    const operation = [
                        {data:this.$store.state.menusData,operation: 'initConfig'}
                    ]
                    $eventBus.$emit('__save__',true,null, operation)
                    $eventBus.$emit('onFlashLesson')
                    clearTimeout(fn)
                }, 500)

                // 默认选中第一个菜单分类
                // const self = this
                // const fn = setTimeout(()=>{
                //     self.$emit('defaultSelectMenu')
                //     console.log('defaultSelectMenu==>')
                //     debugger
                //     clearTimeout(fn)
                // }, 200)
            },
            // 更新导航数据
            async updateNavData({shop, name, fn}){
                console.log('updateNavData==>', shop, name, fn)
                // let addResource =  shop?'addResourceShop' : 'addResource'
                // let getResourceDetail = shop?'getResourceShopDetail':'getResourceDetail'
                // let updateResource = shop?'updateResourceShop':'updateResource'
                //
                // // name存在表示，当前导航不存在，直接创建导航
                // if (name) {
                //     const obj = {
                //         category_id: 0,
                //         name: '系统创建'+ new Date().getMilliseconds(),
                //         sort: 'scenes_stage'
                //     }
                //     obj.clientsId = parseInt(this.$store.state.initConfig.school_id)
                //     obj.attributes = {
                //         is_default: 0,
                //         remark: '',
                //         options: [name]
                //     }
                //     const res = await commonServer.default[addResource](obj)
                //     console.log('创建导航结果', res)
                //     if(res.data && res.data.id) {
                //         let data = this.$_.cloneDeepWith(this.$store.state.menusData)
                //         data.scenes_stage_id = res.data.id
                //
                //         fn && fn(data)
                //
                //         // this.$store.dispatch('setMenusData', data)
                //         // 如果是第一次创建页面，在没有导航的情况下，即先创建导航再创建页面
                //         if (this.optToBlockItem && this.optToBlockItem.fn) {
                //             this.optToBlockItem.fn()
                //         }
                //     }
                //     return false
                // }

                fn && fn()

                // // 1.获取导航详情
                // const res = await commonServer.default[getResourceDetail]({
                //     id: this.$store.state.menusData.scenes_stage_id,
                //     clientsId: this.$store.state.initConfig.school_id
                // })
                // console.log('nav->detail', res)
                // // 2.更新导航
                // let attributes = res.data.attributes
                // attributes.options = this.menusData.blocksForm.map(v=>v.name)
                // commonServer.default[updateResource]({
                //     id: this.$store.state.menusData.scenes_stage_id,
                //     clientsId: this.$store.state.initConfig.school_id,
                //     sort:'scenes_stage',
                //     categoryId: res.data.category_id,
                //     name: res.data.name,
                //     attributes
                // }).then(res=>{
                //     // this.$message.success('更新成功', res)
                //     console.log('导航更新成功==>', res)
                // }).catch(err=>{
                //     this.$message.error('导航操作失败', err)
                // })
            }
        }
    }
</script>
<style>
.column .item{
    flex-direction: column;
    align-items: flex-start;
}
.column .item .el-form-item__content,
.column .item .el-form-item__content .el-cascader,
.column .item .el-form-item__content .el-select
{
    width: 100%;
}
.warn.el-alert--warning.is-light{
    background: #FFFBE6;
    color: rgba(0, 0, 0, 0.65);
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
  }
</style>
<style lang="scss" scoped>
.warn{
    margin-bottom: 20px;

    & /deep/ .el-alert__icon{
        color: #FAAD14;
        position: relative;
        top: 3px;
    }
}
</style>
